module.exports = __webpack_public_path__ + "img/save.4daac3fc.svg";